import { alpha } from "@mui/material/styles";
import { v2CardBg, v2CardBorder, v2LabelSx } from "../../PerformanceDashboardV2/v2Theme";

export const V2_POSITION_ROW_HEIGHT = 32;
export const V2_POSITION_VIRTUAL_BUFFER = 10;
export const V2_POSITION_TABLE_HEADER_HEIGHT = 40;
export const V2_POSITION_VIEWPORT_OFFSET = 320;

export const getV2PositionTableBodyHeight = (measuredContainerHeight = 0) => {
  const measured =
    measuredContainerHeight > 0
      ? measuredContainerHeight - V2_POSITION_TABLE_HEADER_HEIGHT
      : 0;

  if (measured > 0) return measured;

  const estimated =
    typeof window !== "undefined"
      ? window.innerHeight -
        V2_POSITION_VIEWPORT_OFFSET -
        V2_POSITION_TABLE_HEADER_HEIGHT
      : 500;

  return Math.max(estimated, 240);
};

export const cellSx = {
  borderBottom: "1px solid",
  py: 0.55,
  px: 0.65,
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
  fontSize: "0.9rem",
  fontWeight: 600,
};

export const getTableShellSx = (theme) => {
  const isDark = theme.palette.mode === "dark";
  return {
    borderRadius: 2,
    overflow: "hidden",
    border: "1px solid",
    borderColor: isDark ? "rgba(255,255,255,0.36)" : v2CardBorder(theme),
    backgroundColor: v2CardBg(theme),
    boxShadow: isDark ? "none" : "0 1px 3px rgba(0,0,0,0.06)",
  };
};

export const getSideHeaderSx = (theme, side) => {
  const isDark = theme.palette.mode === "dark";
  const tint =
    side === "long"
      ? alpha(theme.palette.success.main, isDark ? 0.14 : 0.1)
      : alpha(theme.palette.error.main, isDark ? 0.14 : 0.1);

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 1.5,
    py: 1,
    borderBottom: "1px solid",
    borderColor: v2CardBorder(theme),
    backgroundColor: tint,
  };
};

export const getHeadCellSx = (theme, { sticky, active }) => {
  const isDark = theme.palette.mode === "dark";
  return {
    ...cellSx,
    py: 0.5,
    backgroundColor: v2CardBg(theme),
    borderBottomColor: v2CardBorder(theme),
    ...(sticky
      ? {
          position: "sticky",
          left: 0,
          zIndex: 3,
          minWidth: 72,
          maxWidth: 88,
          width: 80,
        }
      : null),
    ...(active
      ? {
          color: isDark ? "#FFFFFF" : theme.palette.text.primary,
        }
      : v2LabelSx(theme)),
  };
};

export const getBodyCellSx = (theme, { sticky, color, marketValid } = {}) => {
  const isDark = theme.palette.mode === "dark";
  let bg = v2CardBg(theme);

  if (marketValid === true) {
    bg = alpha(theme.palette.success.main, isDark ? 0.12 : 0.08);
  } else if (marketValid === false) {
    bg = alpha(theme.palette.error.main, isDark ? 0.12 : 0.08);
  }

  return {
    ...cellSx,
    borderBottomColor: v2CardBorder(theme),
    color: color || "text.primary",
    backgroundColor: bg,
    ...(sticky
      ? {
          position: "sticky",
          left: 0,
          zIndex: 1,
          minWidth: 72,
          maxWidth: 88,
          width: 80,
          fontWeight: 700,
          borderRight: `1px solid ${v2CardBorder(theme)}`,
        }
      : null),
  };
};

export const getRowHoverSx = (theme) => {
  const isDark = theme.palette.mode === "dark";
  return {
    cursor: "pointer",
    "& td": {
      backgroundColor: v2CardBg(theme),
    },
    "&:hover td": {
      backgroundColor: isDark
        ? "rgba(255,255,255,0.05)"
        : "rgba(0,0,0,0.03)",
    },
  };
};

export const v2TooltipSlotProps = (theme) => {
  const isDark = theme.palette.mode === "dark";
  return {
    tooltip: {
      sx: {
        p: 1,
        maxWidth: 260,
        backgroundColor: v2CardBg(theme),
        color: theme.palette.text.primary,
        border: `1px solid ${isDark ? "rgba(255,255,255,0.36)" : v2CardBorder(theme)}`,
        boxShadow: isDark
          ? "0 8px 24px rgba(0,0,0,0.45)"
          : "0 8px 24px rgba(0,0,0,0.12)",
        fontSize: "0.78rem",
      },
    },
    arrow: {
      sx: {
        color: v2CardBg(theme),
      },
    },
  };
};
